/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Claim_Error_TitleInputs */

const en_dialog_claim_error_title = /** @type {(inputs: Dialog_Claim_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claim Failed`)
};

const ar_dialog_claim_error_title = /** @type {(inputs: Dialog_Claim_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فشل المطالبة`)
};

const de_dialog_claim_error_title = /** @type {(inputs: Dialog_Claim_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anspruch gescheitert`)
};

const es_dialog_claim_error_title = /** @type {(inputs: Dialog_Claim_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La reclamación ha fallado`)
};

const fr_dialog_claim_error_title = /** @type {(inputs: Dialog_Claim_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la réclamation`)
};

const it_dialog_claim_error_title = /** @type {(inputs: Dialog_Claim_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riscatto fallito`)
};

const ja_dialog_claim_error_title = /** @type {(inputs: Dialog_Claim_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`報酬の受け取りに失敗しました`)
};

const ko_dialog_claim_error_title = /** @type {(inputs: Dialog_Claim_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`리워드 지급 실패`)
};

const pt_br_dialog_claim_error_title = /** @type {(inputs: Dialog_Claim_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha no resgate`)
};

const ru_dialog_claim_error_title = /** @type {(inputs: Dialog_Claim_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось запросить`)
};

const th_dialog_claim_error_title = /** @type {(inputs: Dialog_Claim_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การแลกรับล้มเหลว`)
};

const tr_dialog_claim_error_title = /** @type {(inputs: Dialog_Claim_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talep Başarısız Oldu`)
};

const zh_cn_dialog_claim_error_title = /** @type {(inputs: Dialog_Claim_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`领取失败`)
};

const zh_tw_dialog_claim_error_title = /** @type {(inputs: Dialog_Claim_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`領取失敗`)
};

/**
* | output |
* | --- |
* | "Claim Failed" |
*
* @param {Dialog_Claim_Error_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_claim_error_title = /** @type {((inputs?: Dialog_Claim_Error_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Claim_Error_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_claim_error_title(inputs)
	if (locale === "ar") return ar_dialog_claim_error_title(inputs)
	if (locale === "de") return de_dialog_claim_error_title(inputs)
	if (locale === "es") return es_dialog_claim_error_title(inputs)
	if (locale === "fr") return fr_dialog_claim_error_title(inputs)
	if (locale === "it") return it_dialog_claim_error_title(inputs)
	if (locale === "ja") return ja_dialog_claim_error_title(inputs)
	if (locale === "ko") return ko_dialog_claim_error_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_claim_error_title(inputs)
	if (locale === "ru") return ru_dialog_claim_error_title(inputs)
	if (locale === "th") return th_dialog_claim_error_title(inputs)
	if (locale === "tr") return tr_dialog_claim_error_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_claim_error_title(inputs)
	return zh_tw_dialog_claim_error_title(inputs)
});